/**
 * "Our SI Leadership" on About Us: the public face of the managers in
 * server/ai-staff.js (rank 'manager'), with the public titles the founder
 * chose on 2026-09-27. Same people and portraits as the Staff page.
 *
 * The section's intro ("super intelligence agents", spelled out) is what
 * tells visitors these aren't people; cards carry name and title only.
 * Anywhere this list is reused, bring that disclosure with it.
 *
 * `avatar` is the Staff-page square (cropped through the head, fine small);
 * `portrait` is the 4:5 About Us version with the full head
 * (scripts/extend-staff-portrait-headroom.mjs).
 *
 * aiLeadership.test.js fails when a manager joins or leaves the roster
 * without this list following.
 */
export const AI_LEADERSHIP = [
  { id: 'stephanie', name: 'Stephanie', title: 'VP, Service Quality', avatar: '/staff/stephanie.png', portrait: '/staff/about/stephanie.jpg' },
  { id: 'elliott', name: 'Elliott', title: 'VP, Risk Intelligence', avatar: '/staff/elliott.png', portrait: '/staff/about/elliott.jpg' },
  { id: 'bernard', name: 'Bernard', title: 'VP, Finance & Controller', avatar: '/staff/bernard.png', portrait: '/staff/about/bernard.jpg' },
  { id: 'iris', name: 'Iris', title: 'VP, Customer Insights', avatar: '/staff/iris.png', portrait: '/staff/about/iris.jpg' },
  { id: 'silas', name: 'Silas', title: 'VP, Security & Reliability', avatar: '/staff/silas.png', portrait: '/staff/about/silas.jpg' },
  { id: 'owen', name: 'Owen', title: 'Director, Booking Operations', avatar: '/staff/owen.png', portrait: '/staff/about/owen.jpg' },
  { id: 'audrey', name: 'Audrey', title: 'Director, Operations Assurance', avatar: '/staff/audrey.png', portrait: '/staff/about/audrey.jpg' },
  { id: 'margot', name: 'Margot', title: 'Director, Lifecycle Marketing', avatar: '/staff/margot.png', portrait: '/staff/about/margot.jpg' },
  { id: 'miles', name: 'Miles', title: 'Director, Loyalty & Rewards', avatar: '/staff/miles.png', portrait: '/staff/about/miles.jpg' },
];
